import { useState, useEffect } from 'react';

function getParameter(paramName, defaultValue) {
    const currentURL = new URL(window.location);
    const param = currentURL.searchParams.get(paramName) ?? defaultValue;
    return param === '' ? defaultValue : param;
}

export function useParamsState(paramName, defaultValue) {
    const [param, setParam] = useState(() => {
        return getParameter(paramName, defaultValue);
    });
    // function to set and update a parameter
    useEffect(() => {
        const currentURL = new URL(window.location);
        currentURL.searchParams.set(paramName, param);
        const updatedURL = currentURL.origin + currentURL.pathname + '?' + currentURL.searchParams.toString();
        window.history.replaceState(null, '', updatedURL);
    }, [param]);
    let bool = undefined;
    if(param === 'true') {
        bool = true;
    }
    if(param === 'false') {
        bool = false;
    }
    return [bool ?? param, setParam];
}


function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
